import { defineStore } from 'pinia';
import { API_URL, authFetch } from '../api';

export const useChartStore = defineStore('charts', {
  state: () => ({
    monthlyData: null,
    yearlyData: null,
    loading: false,
    error: null,
  }),
  actions: {
    async fetchChartData(type, startDate = null, endDate = null) {
      this.loading = true;
      try {
        let url = `${API_URL}/charts/${type}-balances`;
        if (startDate || endDate) {
          const params = new URLSearchParams();
          if (startDate) params.append('start_date', startDate);
          if (endDate) params.append('end_date', endDate);
          url += `/?${params.toString()}`;
        }

        const response = await authFetch(url);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        
        // Transform the data to include comments
        if (type === 'monthly') {
          this.monthlyData = {
            bank_accounts: {
              ...data.bank_accounts,
              values: data.bank_accounts.values.map((value, index) => ({
                y: value,
                comments: data.bank_accounts.comments?.[index] || []
              }))
            },
            savings: {
              ...data.savings,
              values: data.savings.values.map((value, index) => ({
                y: value,
                comments: data.savings.comments?.[index] || []
              }))
            }
          };
        } else {
          this.yearlyData = data;
        }
        return data;
      } catch (error) {
        this.error = error;
        throw error;
      } finally {
        this.loading = false;
      }
    }
  }
});